import { useEffect } from 'react';

import type { UseAddProductCategoryEffectsProps } from '@app/pages/Warehouses/ProductCategories/components/AddEditProductCategory/types';

export const useAddEditProductCategoryEffects = ({
  initForm,
  skipForm,
}: UseAddProductCategoryEffectsProps) => {
  useEffect(() => {
    initForm();

    return skipForm;
  }, [initForm, skipForm]);
};
